module.exports = __webpack_public_path__ + "static/media/wave-triangle.f2f0d816.svg";